<template>
  <v-row no-gutters id="logo" dark align="center" style="z-index: 1100; height: 70px">
    <span> Powered by </span>
    <img
      :src="getSrc('White-Text-SVG.svg')"
      width="100px"
      height="auto"
      max-height="70px"
      class="ml-1"
    />
  </v-row>
</template>

<script lang="ts" setup>
import getAssetSrc from '@/utils/getAssetSrc';
function getSrc(partialFilePath: string): string {
  return getAssetSrc(partialFilePath)
}
</script>

<style scoped>
#logo {
  position: absolute;
  bottom: 0px;
  right: 4px;
  color: #ffffff;
  font-size: 1rem;
}
</style>
